export default __webpack_public_path__ + "static/media/small_austin.71b2c09e.png";